export function getAgeBucket(age) {
  if (age <= 2) return "0-2";
  if (age <= 5) return "3-5";
  if (age <= 9) return "6-9";
  if (age <= 12) return "10-12";
  return "13+";
}
